
import FeaturedArticle from '~/components/public/featured/featured-article.vue'
import FeaturedLesson from '~/components/public/featured/featured-lesson.vue'
import FeaturedWorkshop from '~/components/public/featured/featured-workshop.vue'

export default {
  components: {
    'featured-article': FeaturedArticle,
    'featured-lesson': FeaturedLesson,
    'featured-workshop': FeaturedWorkshop,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },

  methods: {
    getComponentKey(modelApiKey) {
      return `featured-${modelApiKey.toLowerCase()}`
    },

    getCardOrientation(index = 0) {
      if (this.isMediumScreen) {
        return index === 0 ? 'vertical' : 'horizontal'
      }

      if (this.isSmallScreen) {
        return index === 0 ? 'horizontal' : 'vertical'
      }

      return 'vertical'
    },
  },

  computed: {
    // Ensure no more than 3 items are shown, even if the array of items contains more
    dataTrimmed() {
      return this.items.slice(0, 3)
    },

    isSmallScreen() {
      return this.$matchesBreakpoint('s')
    },

    isMediumScreen() {
      return this.$matchesBreakpoint('m')
    },
  },
}
